export default __webpack_public_path__ + "static/media/star_filled.90b48acc.svg";